import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../data/firebase";
import { useRole } from "../data/useRole";
import Header from "../components/Header";
import "./BigDatabasePage.css";

export default function LegacyBlacklistPage() {
  const { canEdit, loading: roleLoading } = useRole();
  const [blacklist, setBlacklist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [removing, setRemoving] = useState("");
  const [error, setError] = useState("");

  // Only run Firestore query if editor
  useEffect(() => {
    if (roleLoading || !canEdit) return;
    setLoading(true);
    setError("");
    async function loadBlacklist() {
      try {
        const snap = await getDocs(collection(db, "legacyblacklist-collection"));
        const arr = [];
        snap.forEach(docSnap => {
          const data = docSnap.data();
          arr.push({
            id: docSnap.id,
            raw: data.color || "",
          });
        });
        setBlacklist(arr);
      } catch (e) {
        setError("Error loading blacklist: " + (e?.message || "Unknown error"));
      }
      setLoading(false);
    }
    loadBlacklist();
  }, [removing, canEdit, roleLoading]);

  function parseLegacyCard(raw) {
    if (!raw) return { name: "", info: [] };
    const commaIdx = raw.indexOf(",");
    if (commaIdx === -1) return { name: raw, info: [] };
    const name = raw.slice(0, commaIdx).trim();
    const info = [raw.slice(commaIdx + 1).trim()];
    return { name, info, raw };
  }

  async function handleUnblacklist(id) {
    if (!id) return;
    setRemoving(id);
    await deleteDoc(doc(db, "legacyblacklist-collection", id));
    setRemoving("");
  }

  if (roleLoading) return null;
  if (!canEdit) {
    // Do NOT load Firestore, just show denial message
    return (
      <div className="app">
        <Header title="CCM Tinting Studio" />
        <main className="container" style={{ textAlign: "center", marginTop: 80 }}>
          <h2 style={{ color: "#b83030" }}>Access Denied</h2>
          <p>You do not have permission to view the Legacy Blacklist.</p>
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <Header title="CCM Tinting Studio" />
      <main className="container">
        <h1>Legacy Blacklist</h1>
        {loading ? (
          <div>Loading…</div>
        ) : error ? (
          <div style={{ color: "#b83030" }}>{error}</div>
        ) : blacklist.length === 0 ? (
          <div>No blacklisted formulas.</div>
        ) : (
          <div className="bigdb__grid">
            {blacklist.map((entry, idx) => {
              const card = parseLegacyCard(entry.raw);
              return (
                <article key={entry.id} className="product-card-box bigdb__card" style={{ position: "relative" }}>
                  <style>
                    {`
                      .legacy-badge-local {
                        display: inline-block;
                        margin-top: 0.5em;
                        background: #b83030;
                        color: #fff;
                        border-radius: 6px;
                        font-size: 0.8em;
                        padding: 2px 10px;
                        font-weight: 600;
                        letter-spacing: 0.04em;
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                        z-index: 1;
                        box-shadow: 0 2px 8px rgba(184,48,48,0.14);
                      }
                      .legacy-unbl-button {
                        margin-top: 8px;
                        margin-bottom: 4px;
                        background: #1b8f3e;
                        color: #fff;
                        border: none;
                        border-radius: 5px;
                        padding: 4px 14px;
                        font-size: 0.9em;
                        font-weight: 700;
                        cursor: pointer;
                        transition: background 0.16s;
                      }
                      .legacy-unbl-button:disabled {
                        background: #bbb;
                        color: #fff;
                        cursor: not-allowed;
                      }
                    `}
                  </style>
                  <div className="product-card-box__head">
                    <h3 className="product-card-box__name bigdb__name">{card.name}</h3>
                  </div>
                  {!!(card.info && card.info.length) && (
                    <div className="bigdb__info">
                      {card.info.map((line, j) => (
                        <p key={j} className="bigdb__info-line">
                          {line}
                        </p>
                      ))}
                    </div>
                  )}
                  <span className="legacy-badge-local">Blacklisted</span>
                  <button
                    className="legacy-unbl-button"
                    disabled={removing === entry.id}
                    onClick={() => handleUnblacklist(entry.id)}
                  >
                    {removing === entry.id ? "Un-blacklisting…" : "Un-blacklist"}
                  </button>
                  <div style={{ fontSize: ".78em", color: "#888", marginTop: 12, wordBreak: "break-all" }}>
                    <b>CSV line:</b> <span style={{ fontFamily: "monospace" }}>{entry.raw}</span>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}
